<template>
    <div>
        <div class="d-inline-flex align-items-center justify-content-end text-nowrap">
            <span>{{ transfer.amount }}</span>
            <!-- IK Edytuj kwotę: rozwijane okienko z kwotami przypisanymi do dokumentów i dyspozycji źródłowych -->
            <!-- lewa krawędź okienka równo z lewą krawędzią kolumny Kwota -->
            <b-dropdown :offset="menuOffset"
                        boundary="viewport"
                        class="amount-sources-dropdown m-l-xs"
                        menu-class="amount-sources-menu"
                        no-caret
                        toggle-class="btn-amount-sources"
                        variant="link"
                        @keydown.native="alignMenuToCell"
                        @mousedown.native="alignMenuToCell">
                <template #button-content>
                    <i :data-original-title="__('edit_amount')"
                       class="fas fa-edit"
                       data-placement="top"
                       data-toggle="tooltip"></i>
                </template>
                <table class="amount-sources-table" @click.stop>
                    <tbody>
                    <tr v-for="(source, index) in transfer.sources" :key="index">
                        <td class="p-r-sm">{{ source.made_from === 'disposition' ? __('transfer_source_disposition') : __('transfer_source_document') }}</td>
                        <td class="p-r-sm">{{ shortTransferName(source.transfer_name) }}</td>
                        <td class="text-right">
                            <input v-model="source.amount"
                                   :class="{'is-invalid': isInvalid(source)}"
                                   :readonly="transfer.amount_blocked == 1"
                                   class="form-control form-control-sm text-right"
                                   style="width:100px;"
                                   type="text"
                                   @change="sourceAmountChanged(source)">
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2"></td>
                        <td class="text-right text-bold p-r-xs">{{ transfer.amount }}</td>
                    </tr>
                    </tbody>
                </table>
            </b-dropdown>
        </div>
        <!-- każda kwota pozycji źródłowej musi być > 0; przy sumie 0,00 błąd pokazuje już lista przelewów -->
        <span v-if="hasInvalidSource && transfer.amount != '0,00'" class="tittle-error help-block text-danger d-block">{{ __('gt_0_or_null') }}</span>
    </div>
</template>

<script>
import {Money} from "../../services/Money";

export default {
    name: "AmountSources",
    props: ['transfer'],
    data() {
        return {
            money: new Money(),
            menuOffset: 0
        };
    },
    computed: {
        hasInvalidSource() {
            return (this.transfer.sources || []).some(source => this.isInvalid(source));
        }
    },
    methods: {
        //okienko domyślnie zaczyna się od ikonki - przesuwamy w lewo do początku komórki;
        //liczone przed kliknięciem, bo b-dropdown tworzy popper zaraz po @show, zanim dotrze nowy :offset
        alignMenuToCell(event) {
            let cell = this.$el.closest('td');
            let toggle = this.$el.querySelector('.btn-amount-sources');
            if (cell && toggle && toggle.contains(event.target)) {
                this.menuOffset = Math.round(cell.getBoundingClientRect().left - toggle.getBoundingClientRect().left);
            }
        },
        //Tytułem obcięty do 50 znaków + trzykropek
        shortTransferName(name) {
            name = name || '';
            return name.length > 50 ? name.substring(0, 50) + '...' : name;
        },
        isInvalid(source) {
            let amount = this.money.toFloat(source.amount);
            return isNaN(amount) || amount <= 0;
        },
        //każda zmiana kwoty źródła od razu przelicza kwotę przelewu (suma źródeł)
        sourceAmountChanged(source) {
            let amount = this.money.toFloat(source.amount);
            if (amount < 0 || isNaN(amount)) {
                amount = 0;
            }
            source.amount = this.money.localize(amount);

            let sum = 0;
            for (let item of this.transfer.sources) {
                let value = this.money.toFloat(item.amount);
                if (!isNaN(value)) {
                    sum += value;
                }
            }
            this.transfer.amount = this.money.localize(sum);
        }
    }
}
</script>

<style>
/* kolor jak pozostałe ikonki w wierszu (.table-icons) */
.amount-sources-dropdown .btn-amount-sources {
    color: #495966;
    padding: 0;
    border: 0;
    line-height: 1;
    vertical-align: baseline;
}

.amount-sources-dropdown .btn-amount-sources:focus,
.amount-sources-dropdown .btn-amount-sources:active {
    box-shadow: none;
}

.amount-sources-dropdown .btn-amount-sources::after {
    display: none;
}

.amount-sources-menu {
    min-width: 0;
    padding: 6px 10px;
    font-size: 12px;
}

.amount-sources-table td {
    padding-top: 2px;
    padding-bottom: 2px;
    white-space: nowrap;
}
</style>
